import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnCloseModalAbout = generator('onCloseModalAbout');

export {
  HPMSOnCloseModalAbout,
};
